module.exports = __webpack_public_path__ + "img/android-mobapp.eeb6add6.png";